import { handleActions } from "redux-actions";
import { Map } from "immutable";
import _ from "lodash";

import {
    CONNECTION_REQUESTS_FAILURE,
    CONNECTION_REQUESTS_FILTER_CHANGE,
    CONNECTION_REQUESTS_REQUEST_START,
    CONNECTION_REQUESTS_RESULT,
    CONNECTION_REQUESTS_SORT_CHANGE,
    CONNECTION_REQUESTS_SEARCH_CHANGE,
    CONNECTION_REQUEST_EDIT_SUCCESS,
    CONNECTION_REQUESTS_COUNT,
    CONNECTION_REQUESTS_RETAILER_COMPANIES_START,
    CONNECTION_REQUESTS_RETAILER_COMPANIES_SUCCESS,
    CONNECTION_REQUESTS_RETAILER_COMPANIES_FAILURE,
    SCOPE_BRAND_SET,
} from "constants/action-types";

export class ConnectionRequestsState {
    result: any[] = [];
    isFetching = false;
    error?: any;
    nextPage?: any;
    hasMoreResults = false;
    filters = Map<string, any>();
    isDeleting = false;
    __sort = "created_on";
    __sort_order = "desc";
    __search = "";
    __limit = 50;
    pendingCount: 0;
    retailerCompanies: any[] = [];
    existingBuyers: any;
    isErrorFetchingRetailerCompanies: false;
    isFetchingRetailerCompanies: false;
}

// Not exported type alias, used locally for shorter signatures
type State = ConnectionRequestsState;

const initialState = new ConnectionRequestsState();

export const connectionRequests = handleActions<State, any>(
    {
        [CONNECTION_REQUESTS_REQUEST_START]: (state: State, { payload }): State => ({
            ...state,
            result: payload.reset ? [] : state.result,
            isFetching: true,
            nextPage: undefined,
            hasMoreResults: false,
        }),
        [CONNECTION_REQUESTS_RESULT]: (state: State, { payload, meta, error }: any): State => {
            meta = meta || {};
            let result;
            if (error) {
                result = state.result;
            } else if (meta.replace) {
                result = payload;
            } else {
                result = state.result.concat(payload);
            }

            return {
                ...state,
                result,
                nextPage: meta.next,
                hasMoreResults: !!meta.next,
                isFetching: false,
                error: error ? payload : error,
            };
        },
        [CONNECTION_REQUESTS_FAILURE]: (state: State, { payload, error }): State => ({
            ...state,
            isFetching: false,
            error: error ? payload : undefined,
            hasMoreResults: !!state.nextPage,
        }),
        [CONNECTION_REQUESTS_SEARCH_CHANGE]: (state: State, { payload }): State => {
            const { search } = payload;
            const filters = state.filters.set("__search", search);
            return { ...state, __search: search, filters };
        },
        [CONNECTION_REQUESTS_FILTER_CHANGE]: (state: State, { payload }): State => {
            const { filters } = payload;
            return { ...state, filters, __search: filters.get("__search") };
        },
        [CONNECTION_REQUESTS_SORT_CHANGE]: (state: State, { payload }): State => {
            const { __sort, __sort_order } = payload;
            return { ...state, __sort, __sort_order };
        },
        [CONNECTION_REQUEST_EDIT_SUCCESS]: (state: State, { payload }): State => {
            const { id, action, status } = payload;
            const statusFilter = state.filters.get("status");
            const archiveAction = ["archive", "unarchive"].includes(action);
            const statusAction = ["approve", "deny", "block", "unblock", "review"].includes(action);
            const archiveChanged = archiveAction && state.filters.get("archived") !== "all";
            const statusChanged = statusAction && statusFilter && !statusFilter.includes(status);
            if (archiveChanged || statusChanged) {
                return { ...state, result: _.filter(state.result, (x) => x !== id) };
            }
            return state;
        },
        [CONNECTION_REQUESTS_COUNT]: (state: State, { payload }) => ({ ...state, pendingCount: payload }),
        [CONNECTION_REQUESTS_RETAILER_COMPANIES_START]: (state: State) => {
            return {
                ...state,
                retailerCompanies: [],
                existingBuyers: null,
                isErrorFetchingCompanies: false,
                isFetchingRetailerCompanies: true,
            };
        },
        [CONNECTION_REQUESTS_RETAILER_COMPANIES_SUCCESS]: (state: State, { payload }) => {
            return {
                ...state,
                retailerCompanies: payload.company,
                existingBuyers: payload.buyerRoles,
                isErrorFetchingRetailerCompanies: false,
                isFetchingRetailerCompanies: false,
            };
        },
        [CONNECTION_REQUESTS_RETAILER_COMPANIES_FAILURE]: (state: State) => {
            return {
                ...state,
                retailerCompanies: [],
                isErrorFetchingRetailerCompanies: true,
                isFetchingRetailerCompanies: false,
            };
        },
        [SCOPE_BRAND_SET]: () => initialState,
    } as any,
    initialState,
);
